import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StorageService } from './storage.service';
import { RequestsServices } from './requests.service';
import { ToasterService } from './toaster.service';
import { CookieService } from 'ngx-cookie-service';
import { select, Store } from '@ngrx/store';
import { getAccountType, getActiveBusiness, getUser } from '../store/selectors/auth.selectors';
import { accountRetrieve } from 'src/app/store/actions/auth.actions';

@Injectable()
export class UserService {

  user;
  activeBusiness;
  accountType;

  private accountProfiles = {
    '5a1ef473694cfe4bc3935212': 'master',
    '5a1ef4b2694cfe4bc3935213': 'finance',
    '5a1ef508694cfe4bc3935215': 'communication',
    '5a1ef50d694cfe4bc3935217': 'employee',
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    public request: RequestsServices,
    public storage: StorageService,
    public toaster: ToasterService,
    private router: Router,
    private cookieService: CookieService,
    private store: Store
  ) {
    this.store.pipe(select(getUser)).subscribe(user => this.user = user);
    this.store.pipe(select(getActiveBusiness)).subscribe(activeBusiness => this.activeBusiness = activeBusiness);
    this.store.pipe(select(getAccountType)).subscribe(accountType => this.accountType = accountType);
  }

  public getLoggedUser(): any {
    return this.user;
  }

  public requestAccountConfig(): void {
    this.store.dispatch(accountRetrieve());
  }

  public getHiddenApplicationBlocks(activeAccount): [] {
    return activeAccount && activeAccount.hidden_application_blocks
      ? activeAccount.hidden_application_blocks
      : [];
  }

  public getUserLevel(): string {
    if (this.user) {
      return this.accountProfiles[this.user.profilesId];
    }
  }

  public getTypeAccount(): string {
    return this.accountType;
  }

  public getLoggedAccount(): any {
    return this.activeBusiness;
  }

  public getAccountAddresses(): Array<any> {
    const account = this.getLoggedAccount();
    const accountType = this.getTypeAccount();
    let accountAddresses = [];

    let type;
    let modelId;

    switch (accountType) {
      case 'company':
          type = 'company';
          modelId = account.id;
          break;
      case 'establishment':
          type = 'establishment';
          modelId = account.id;
          break;
    }

    if (type === 'company') {
      this.request.get({path: 'companies', pathParam: `/${modelId}/addresses`}).then((addresses) => {
        // Update the localStorage.
        accountAddresses = addresses;
      }, (err) => {
        this.toaster.error('Aviso!', 'Erro ao resgatar endereços de empresa', false, 4000);

      });
    } else if (type === 'establishment') {
      this.request.get({path: 'establishments', pathParam: `/${modelId}/addresses`}).then((addresses) => {
        // Update the localStorage.
        accountAddresses = addresses;
      }, (err) => {
        this.toaster.error('Aviso!', 'Erro ao resgatar endereços de negócio', false, 4000);
      });
    }

    return accountAddresses;
  }

  public login(data): any {
    return this.request.post('customers', data, 'login');
  }

  public updateIntercomUser(): void {
    if (this.user) {
      const { id, customerId, first_name, email, created_at, profilesId, typeBusiness } = this.user;
      const { name, customer_profile } = this.activeBusiness;

      (async () => {
        while (!window.hasOwnProperty('Intercom')) {
          await new Promise(resolve => setTimeout(resolve, 1000));
        }

        (window as any).Intercom('update', {
          app_id: 'yb62gvp9',
          user_id: id,
          customer_id: customerId,
          name: first_name,
          email,
          date_created: created_at,
          profile: this.getProfileDescription(profilesId),
          type_contract: customer_profile ? this.getCompanyContract(customer_profile) : 'Sem Contrato',
          company_name: name,
          company_kind: typeBusiness
        });
      })();
    }
  }

  public getProfileDescription(profileId: string): string {
    const profileDescription = {
      '5a1ef473694cfe4bc3935212': 'Master',
      '5a1ef4b2694cfe4bc3935213': 'Financeiro',
      '5a1ef508694cfe4bc3935215': 'Comunicação',
      '5a1ef50d694cfe4bc3935217': 'Funcionário',
    };

    return profileDescription[profileId];
  }

  public getCompanyContract(typeContract: string): string {
    const contractDescription = {
      association: 'Associação',
      adhesion_sheet: 'Adesão (Folha)',
      adhesion_b2c: 'Adesão (B2C)',
      outbound_customer: 'Outbound',
      saas_customer: 'SaaS',
      partner: 'Parceiro de Negócio',
      pilot: 'Projeto Piloto',
      trial: 'Trial / Em Fase de Experimentação',
    };

    return contractDescription[typeContract];
  }

  public canParticipatePrizeDraw() {
    const account = this.getLoggedAccount();

    if (account && account.prize_draw) {
      return account.prize_draw.status === 'enable';
    } else {
      return false;
    }
  }
}
